import { render, staticRenderFns } from "./BetterKnowPage.vue?vue&type=template&id=666fcc1a&scoped=true"
import script from "./BetterKnowPage.vue?vue&type=script&lang=js"
export * from "./BetterKnowPage.vue?vue&type=script&lang=js"
import style0 from "./BetterKnowPage.vue?vue&type=style&index=0&id=666fcc1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666fcc1a",
  null
  
)

export default component.exports